import Alpine from "alpinejs";
import CheckoutForm from ":/components/CheckoutForm";
import NextDayProcessingMessage from ":/components/NextDayProcessingMessage";

Alpine.data('CheckoutForm', CheckoutForm)
Alpine.data('NextDayProcessingMessage', NextDayProcessingMessage)
